import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toNumber',
    standalone: false
})
export class ToNumberPipe implements PipeTransform {
  public transform(value: string): any {
    const retNumber = Number(value);
    return isNaN(retNumber) ? 0 : retNumber;
  }
}
